"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Certificate;
(function (Certificate) {
    Certificate[Certificate["EIGHTEEN"] = 0] = "EIGHTEEN";
    Certificate[Certificate["FIFTEEN"] = 1] = "FIFTEEN";
    Certificate[Certificate["TWELVE"] = 2] = "TWELVE";
    Certificate[Certificate["PG"] = 3] = "PG";
    Certificate[Certificate["U"] = 4] = "U";
})(Certificate = exports.Certificate || (exports.Certificate = {}));
